import { PulseEnvironment } from '@pulse/browser-shared';
import { AnalyticsPlugin, BuiltinEvents } from '@pulse/common';
import { mergeMap } from 'rxjs';
import { ActivityTracker } from '../../services';

export class PopupEventPlugin implements AnalyticsPlugin {
    constructor(
        private activityTracker: ActivityTracker,
        private env: PulseEnvironment,
    ) {}

    init() {
        this.activityTracker
            .mutations()
            .pipe(mergeMap((event) => event.mutatedElements))
            .subscribe((element: any) => {
                if (element) {
                    this.env.win.dataLayer?.push({
                        pulse: 'event',
                        event_type: BuiltinEvents.POPUP,
                        data: {
                            component: element.component,
                            component_type: element.componentType,
                            popup_source: {
                                section: element.section.name,
                                group: element.section.group,
                            },
                            action: element.mutationType === 'addedNodes' ? 'open' : 'close',
                            click_source: {
                                tab_id: this.activityTracker.lastClickSourceInformation?.tab_id,
                                url: this.activityTracker.lastClickSourceInformation?.url,
                                section: this.activityTracker.lastClickSourceInformation?.name,
                                group: this.activityTracker.lastClickSourceInformation?.group,
                                popup_component:
                                    this.activityTracker.lastClickSourceInformation?.popupComponent,
                                popup_component_type:
                                    this.activityTracker.lastClickSourceInformation
                                        ?.popupComponentType,
                                element: {
                                    id:
                                        this.activityTracker.lastClickSourceInformation?.element
                                            ?.id ||
                                        this.activityTracker.lastClickSourceInformation?.element
                                            ?.name,

                                    name: this.activityTracker.lastClickSourceInformation?.element
                                        ?.name,
                                    type: this.activityTracker.lastClickSourceInformation?.element
                                        ?.nodeName,
                                    class_list:
                                        this.activityTracker.lastClickSourceInformation?.element
                                            ?.classList,
                                    value: this.activityTracker.lastClickSourceInformation?.element
                                        ?.text,
                                },
                                additional_properties:
                                    this.activityTracker.lastClickSourceInformation
                                        ?.additionalProperties,
                            },
                            additional_properties: element?.additionalProperties,
                        },
                    });
                }
            });
    }
}
